
const templates = {
  "Projekt": require("../projekty/projekt.list.table.html"),
  "Servis": require("../servis/servis.list.table.html"),
  "Poziadavka": require("../poziadavky/poziadavka.list.table.html"),
  "Osoba": require("../adresar/osoba.list.table.html"),
  "Zakaznik": require("../zakaznici/zakaznik.list.table.html"),
  "Objekt": require("../objekty/objekt.list.table.html"),
  "Order": require("../orders/order.list.table.html"),
  "PrevadzkovaKniha": require("../prevadzkova-kniha/prevadzkova-kniha.list.table.html"),
};

const filters = {
  //"Osoba": require("../adresar/filter.html"),
  "Zakaznik": require("../adresar/filter.html"),
  "Poziadavka": require("../poziadavky/filter.html"),
  "Projekt": require("../projekty/filter.html"),
}

export default function ItemListDirective($compile) {
  return {
    restrict: "E",
    scope: {
      "source": "=",
      "type": "=",
      "title": "=listTitle"
    },
    link: function(scope, element){
      scope.alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

      var innerscope, tpl, ftpl;
      scope.$watch("type", function(){
        console.log("type changed, recompiling", scope.type, scope.source);
        if(innerscope) innerscope.$destroy();
        if(tpl) tpl.remove();
        if(ftpl) ftpl.remove();
        tpl = angular.element("<div>"+(templates[scope.type]||"Unknown type {{type}}")+"</div>");
        $compile(tpl)(innerscope = scope.$new());
        element.find(".table").append(tpl);
        if(filters[scope.type]){
          ftpl = angular.element("<div>"+filters[scope.type]+"</div>");
          $compile(ftpl)(innerscope);
          element.find(".filter").append(ftpl);
        }
        console.log(innerscope);
      })
    },
    template: require("./ItemList.html")
  }
}


// WEBPACK FOOTER //
// ./src/DataTable/ItemListDirective.js